import '@/assets/javascripts/on/utility-constant/debouncer'
import { onDOMContentLoaded } from '@/helpers/event'
;(function () {
  const Debouncer = On.Debouncer()

  On.VideoAspectRatioKeeper = {
    selector: '.js-video-aspect-ratio-keeper',
    defaultAspectRatio: 1 / 0.7,

    init() {
      window.addEventListener('resize', () => this.resizeHandler())
      this.keepAspectRatios()
    },

    resizeHandler() {
      Debouncer.debounce({
        callback: () => this.keepAspectRatios(),
        debounceTime: 200,
      })
    },

    keepAspectRatios() {
      document.querySelectorAll(this.selector).forEach(el => {
        const embeds = el.querySelectorAll('iframe, embed')
        const videos = [...embeds].filter(embed => embed.src.match(/vimeo|youtube/i))

        videos.forEach(videoEl => {
          let aspectRatio
          if (videoEl.width && videoEl.height) {
            aspectRatio = videoEl.width / videoEl.height
          } else {
            aspectRatio = this.defaultAspectRatio
          }

          videoEl.style.height = videoEl.offsetWidth / aspectRatio + 'px'
        })
      })
    },
  }

  onDOMContentLoaded().then(() => On.VideoAspectRatioKeeper.init())
})()
